import script from "./MaterialY.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaterialY.vue?vue&type=script&setup=true&lang=ts"

import "./MaterialY.vue?vue&type=style&index=0&id=0836bfbd&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0836bfbd"]])

export default __exports__